import { portalPaths } from '@provision/portal-routes';
import { useCallback } from 'react';
import { Conversation } from 'src/graphql/entities/conversation/conversation.types';
import { ConditionInput, EntityNames } from 'src/graphql/types';
import { BaseSelectedView } from 'src/pages/CustomViews/custom-views-selected-view/base-selected-view';
import { TabType, useCustomView, useGlobalTabs } from 'src/utils/hooks';
import { useNavigateRoute } from 'src/utils/routing';
import { Platform } from 'src/utils/system';

export const ExpandedConversations = ({
  viewFilters,
  viewId,
  customViewType,
}: {
  viewFilters: ConditionInput[];
  viewId: string;
  customViewType: EntityNames;
}) => {
  const { navigate } = useNavigateRoute();
  const { openInTab } = useGlobalTabs();
  const customViewId = useCustomView(customViewType)?.customViewId;
  const onRecordClick = useCallback(
    <T extends Conversation>(_: T['id'], record: T, event?: React.MouseEvent) => {
      if (Platform.isMacOS ? event?.metaKey : event?.ctrlKey) {
        openInTab({ type: TabType.Conversation, entity: record }, { customViewId }, false);
        return;
      }
      navigate(portalPaths.conversation.full(record.friendlyId), { state: { customViewId } });
    },
    [customViewId, navigate, openInTab],
  );

  return (
    <BaseSelectedView<Conversation>
      isStaticView
      entity={EntityNames.Conversation}
      viewId={viewId}
      onRecordClick={onRecordClick}
      viewFilters={viewFilters}
      title="Conversations"
      leftHeaderAdornment=""
    />
  );
};
